import Footer from "../Common/Footer";
import Header from "../Common/Header";

function About() {
  return (
    <>
  <Header />
    {/* Start About Area */}
    <div className="about-area pt-100 pb-100">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="single-about-image">
              <img src="assets/images/about/about-1.webp" alt="about-1" />
              <div className="about-shape">
                <img
                  src="assets/images/about/about-shape-1.webp"
                  alt="about-shape"
                />
              </div>
              <div className="about-shape-1">
                <img
                  src="assets/images/about/about-shape-2.webp"
                  alt="about-shape"
                />
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="single-about-content">
              <div className="section-title left-title">
                <span className="top-title">Reliable Online Platform
                </span>
                <h2>
                We make personal finance easy, convenient & transparent

                </h2>
                <p>
                Using data and technology innovations, we help you choose the most suited offers across loans and cards. Our algorithm-based technology platform provides you with access to multiple personal credit offers, ease of comparison of multiple offers available and unbiased advice. From application to disbursal, SmartU World will accompany you at each step, till the disbursal of loan or issuance of credit card.


                </p>
              </div>
              <div className="d-flex">

              <ul className="mr-20" style={{marginRight:20}}>
                <li className="list-inline">
                  <img
                    src="assets/images/about/about-icon.svg"
                    alt="about-icon"
                  />{" "}
                  Powerful Mobile & Online App
                </li>
                <li className="list-inline">
                  <img
                    src="assets/images/about/about-icon.svg"
                    alt="about-icon"
                  />
                 Commitment Free
                </li>
                <li className="list-inline">
                  <img
                    src="assets/images/about/about-icon.svg"
                    alt="about-icon"
                  />
                 Full Data Privacy Compliance
                </li>
              </ul>
              <ul>
                <li className="list-inline">
                  <img
                    src="assets/images/about/about-icon.svg"
                    alt="about-icon"
                  />{" "}
                  Free Plan Available

                </li>
                <li className="list-inline">
                  <img
                    src="assets/images/about/about-icon.svg"
                    alt="about-icon"
                  />
                100% Transparent Cost

                </li>
                <li className="list-inline">
                  <img
                    src="assets/images/about/about-icon.svg"
                    alt="about-icon"
                  />
                 Debit Mastercard Included
                </li>
              </ul>
              </div>
             
            </div>
          </div>
        </div>
      </div>
      <div className="about-shape3">
        <img src="assets/images/about/about-shape-3.webp" alt="image" />
      </div>
    </div>
    {/* End About Area */}
   

   {/* Start Our Services Area */}
  <div className="services-area pt-100 pb-70">
    <div className="container">
      <div className="services-top-item d-flex align-items-end justify-content-between">
        <div className="section-title left-title">
          <h2>Get Set Up And Start In Minutes
          </h2>
        </div>
      
      </div>
      <div className="row">
        <div className="col-lg-3 col-sm-6 col-md-6">
          <div className="single-services-card d-flex align-items-center">
            <div className="services-icon">
              <img src="assets/images/services/couple.svg" alt="couple" />
            </div>
            <h3>
            1. Create Account

            </h3>
          </div>
        </div>
        <div className="col-lg-3 col-sm-6 col-md-6">
          <div className="single-services-card d-flex align-items-center">
            <div className="services-icon">
              <img src="assets/images/services/home.svg" alt="home" />
            </div>
            <h3>
            2. Verify Identity

            </h3>
          </div>
        </div>
      
        <div className="col-lg-3 col-sm-6 col-md-6">
          <div className="single-services-card d-flex align-items-center">
            <div className="services-icon bg-icon-color1">
              <img src="assets/images/services/heart.svg" alt="heart" />
            </div>
            <h3>
            3. Tap Your Account
            </h3>
          </div>
        </div>
        <div className="col-lg-3 col-sm-6 col-md-6">
          <div className="single-services-card d-flex align-items-center">
            <div className="services-icon bg-icon-color2">
              <img src="assets/images/services/car.svg" alt="car" />
            </div>
            <h3>
            4. Confirm & Send
            </h3>
          </div>
        </div>
  
      </div>
    </div>
  </div>
  {/* End Our Services Area */}

    {/* Start About Three Area */}
    <div className="about-three-area pb-100">
    <div className="container">
      <div className="row align-items-center">
        <div className="col-lg-6">
        <div class="single-banner-2-img">
                            <img src="assets/images/banner/banner-2-img-2.webp" alt="banner1" />
                            <div class="banner-2main">
                                <img src="assets/images/banner/banner-2-img-1.webp" alt="banner2" />
                            </div>
                        </div>
        </div>
        <div className="col-lg-6">
          <div className="single-about-three-content">
            <div className="section-title left-title">
              <span className="top-title">Services Worldwide

              </span>
              <h2>Life at SmartU World…Together, we are stronger!</h2>
             <p>We at SmartUWorld.com, are as proud of our culture and values as we are of our growth. We believe in an open and friendly environment for the SmartU World family that encourages free flowing ideas, teamwork and relentless execution.

</p>
            </div>
            <div className="row">
              <div className="col-lg-6 col-sm-6 col-md-6">
                <div className="about-three-list">
                  <img
                    src="assets/images/about/about-three-check.svg"
                    alt="check"
                  />{" "}
                  Reliable Online Payment

                </div>
                <div className="about-three-list">
                  <img
                    src="assets/images/about/about-three-check.svg"
                    alt="check"
                  />{" "}
                
                Best Networking

                </div>
              </div>
              <div className="col-lg-6 col-sm-6 col-md-6">
                <div className="about-three-list">
                  <img
                    src="assets/images/about/about-three-check.svg"
                    alt="check"
                  />{" "}
                

                Low Transaction Fee

                </div>
                <div className="about-three-list">
                  <img
                    src="assets/images/about/about-three-check.svg"
                    alt="check"
                  />{" "}
               Secure Payment Service



                </div>
              </div>

              <div className="col-lg-6 col-sm-6 col-md-6">
                <div className="about-three-list">
                  <img
                    src="assets/images/about/about-three-check.svg"
                    alt="check"
                  />{" "}
                

                Affordable Security Packages


                </div>
             
              </div>


            </div>
          
          </div>
        </div>
      </div>
    </div>
    <div className="about-three-shape">
      <img
        src="assets/images/about/about-three-shape-1.webp"
        alt="about-shape"
      />
    </div>
    <div className="about-three-shape2">
      <img
        src="assets/images/about/about-three-shape-2.webp"
        alt="about-shape"
      />
    </div>
  </div>
  {/* End About Three Area */}
      
  <Footer />
  </>

  );
}

export default About;
